import type { FlowsType } from "@/types/entities/flows";
import {
  Badge,
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
  Icon,
  RowCard,
} from "@elaniintc/goes-design-system";
import SubFlowCard from "./sub-flow";
import { NavLink } from "react-router";
import { useMemo } from "react";
import { DotComponent, ParentLineComponent } from "./ui";
import { getFlowBadgeLabel, getFlowBadgeColor } from "./utils";

interface Props {
  data: FlowsType;
  processStatus?: "PUBLISHED" | "INACTIVE" | "ON_CONSTRUCTION";
  onEdit?: (id: string) => void;
  onEditSubFlow?: (id: string) => void;
  handleDuplicateFlow: (id: string) => void;
  onViewExecutions?: (id: string) => void;
  onDeleteFlow: (id: string) => void;
  onNewVersion: (id: string) => void;
  onStatusChange: (
    id: string,
    status: "DRAFT" | "PUBLISHED" | "DEPRECATED",
  ) => void;
  isVersionLocked?: boolean;
}

const ParentFlowCard = ({
  data,
  //processStatus,
  onViewExecutions,
  handleDuplicateFlow,
  onEdit,
  onEditSubFlow,
  onDeleteFlow,
  //onStatusChange,
  onNewVersion,
  isVersionLocked = false,
}: Props) => {
  const isParent = useMemo(() => {
    return (data?.child_flows?.length ?? 0) > 0;
  }, [data]);

  // let statusColor = "";
  // if (data.status === "DRAFT" || data.status === "IN_PROCESS")
  //   statusColor = "action";
  // else if (data.status === "PUBLISHED") statusColor = "success";
  // else if (data.status === "DEPRECATED") statusColor = "danger";
  // const getLabel = () => {
  //   if (data.status === "DRAFT" || data.status === "IN_PROCESS")
  //     return "Borrador";
  //   else if (data.status === "PUBLISHED") return "Publicado";
  //   else if (data.status === "DEPRECATED") return "Deprecado";
  //   return "Desconocido";
  // };

  return (
    <div key={data.id} className="flex flex-col gap-2 relative overflow-hidden">
      {isParent && (data.child_flows?.length ?? 0) > 1 && (
        <ParentLineComponent />
      )}

      <div className="flex">
        <DotComponent shouldShow={isParent} />
        <NavLink
          to={`/procesos/${data.process_id}/flujo/${data.id}`}
          className="flex-auto"
        >
          <RowCard
            title={data.name || "Sin nombre"}
            subtitle={data.version ? `Versión ${data.version}` : ""}
            color="action"
            icon={{
              name: "user-circle",
              type: "fas",
              size: "lg",
            }}
          >
            <RowCard.Right>
              <div className="flex gap-2 items-center">
                <Badge
                  variant={
                    getFlowBadgeColor(data) as
                      | "neutral"
                      | "success"
                      | "action"
                      | "warning"
                      | "danger"
                    //statusColor as "neutral" | "success" | "action" | "warning"
                  }
                  size="xs"
                  shape="square"
                >
                  {getFlowBadgeLabel(data)}
                  {/* {getLabel()} */}
                </Badge>
                {/* {data.review_status === "DENIED" && (
                  <Badge variant="danger" size="xs" shape="square">
                    Rechazado
                  </Badge>
                )}
                {data.review_status === "APPROVED" &&
                  statusColor !== "success" && (
                    <Badge variant="success" size="xs" shape="square">
                      Aprobado
                    </Badge>
                  )} */}
                <DropdownMenu>
                  <DropdownMenuTrigger asChild>
                    <Button
                      variant="ghost"
                      size="xs"
                      className="size-8 cursor-pointer"
                    >
                      <Icon type="far" name="ellipsis-vertical" />
                    </Button>
                  </DropdownMenuTrigger>
                  <DropdownMenuContent
                    className="w-[222px] min-w-56 rounded-lg border-neutral text-body font-normal p-2 font-geist"
                    side="bottom"
                    align="end"
                    sideOffset={4}
                  >
                    {!isVersionLocked && (
                      <>
                        <DropdownMenuGroup>
                          <DropdownMenuItem
                            className="hover:bg-neutral-object-accent-silent py-2 px-3 cursor-pointer"
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              if (onEdit) onEdit(data.id!);
                            }}
                          >
                            Editar flujo
                          </DropdownMenuItem>

                          <DropdownMenuItem
                            className="hover:bg-neutral-object-accent-silent py-2 px-3 cursor-pointer"
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              handleDuplicateFlow(data.id!);
                            }}
                          >
                            Duplicar flujo
                          </DropdownMenuItem>
                          <DropdownMenuItem
                            className="hover:bg-neutral-object-accent-silent py-2 px-3 cursor-pointer"
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              onNewVersion(data.id!);
                            }}
                          >
                            Crear nueva versión
                          </DropdownMenuItem>

                          {data.status !== "PUBLISHED" && (
                            <DropdownMenuItem
                              className="hover:bg-neutral-object-accent-silent py-2 px-3 cursor-pointer"
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                if (onDeleteFlow) onDeleteFlow(data.id!);
                              }}
                            >
                              Eliminar flujo
                            </DropdownMenuItem>
                          )}
                        </DropdownMenuGroup>
                        <DropdownMenuSeparator className="bg-(--border-neutral-quiet) my-2.5" />
                      </>
                    )}
                    <DropdownMenuGroup>
                      {/* {data?.review_status === "APPROVED" &&
                        data?.status !== "PUBLISHED" && (
                          <DropdownMenuItem
                            className="hover:bg-neutral-object-accent-silent py-2 px-3 cursor-pointer"
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              if (onStatusChange)
                                onStatusChange(data.id!, "PUBLISHED");
                            }}
                          >
                            Aprobar flujo
                          </DropdownMenuItem>
                        )}
                      {data?.status === "PUBLISHED" &&
                        processStatus !== "PUBLISHED" && (
                          <DropdownMenuItem
                            className="hover:bg-neutral-object-accent-silent py-2 px-3 cursor-pointer"
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              if (onStatusChange)
                                onStatusChange(data.id!, "DEPRECATED");
                            }}
                          >
                            Deprecar flujo
                          </DropdownMenuItem>
                        )} */}
                      <DropdownMenuItem
                        className="hover:bg-neutral-object-accent-silent py-2 px-3 cursor-pointer"
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          if (onViewExecutions) onViewExecutions(data.id!);
                        }}
                      >
                        Ejecuciones
                      </DropdownMenuItem>
                    </DropdownMenuGroup>
                  </DropdownMenuContent>
                </DropdownMenu>
              </div>
            </RowCard.Right>
          </RowCard>
        </NavLink>
      </div>
      <div className="flex flex-col gap-2">
        {data.child_flows?.map((cf) => {
          return (
            <SubFlowCard
              data={cf}
              handleDuplicateFlow={handleDuplicateFlow}
              onEdit={onEditSubFlow}
              key={cf.id || ""}
              isFirst={
                (data.child_flows?.length ?? 0) > 0 &&
                cf.id === data.child_flows![0].id
              }
              isLast={
                (data.child_flows?.length ?? 0) > 0 &&
                cf.id === data.child_flows![data.child_flows!.length - 1].id
              }
              onDeleteFlow={onDeleteFlow}
              onViewExecutions={onViewExecutions}
              parentVersion={data.version}
              isVersionLocked={isVersionLocked}
            />
          );
        })}
      </div>
    </div>
  );
};

export default ParentFlowCard;
